import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import { ChatModule } from "./components/Chat/ChatModule";
import HomePage from "./pages/Home";
import PrestationsPage from "./pages/Prestations";
import SoftwarePage from "./pages/Software";
import PricingPage from "./pages/Pricing";
import ContactPage from "./pages/Contact";
import RecruitmentPage from "./pages/Recruitment";
import CookiePreferencesPage from "./pages/CookiePreferences";
import AccountDeletionPage from "./pages/AccountDeletion";
import PrivacyPolicyPage from "./pages/PrivacyPolicy";
import { usePalette } from "./utils/theme";
import { i18n } from "./utils/i18n";
import { cls } from "./utils/helpers";
import { detectLanguage, saveLanguagePreference } from "./utils/language";
import { detectTheme, saveThemePreference } from "./utils/themeStorage";

function AppContent() {
  const location = useLocation();
  const [lang, setLang] = useState(() => detectLanguage());
  const [themeState, setThemeState] = useState(() => detectTheme());

  const theme = themeState.theme;
  const hasExplicitPref = themeState.hasExplicitPref;

  useEffect(() => {
    if (!hasExplicitPref) {
      const mql = window.matchMedia("(prefers-color-scheme: dark)");
      const handler = (e) => {
        setThemeState({ theme: e.matches ? "dark" : "light", hasExplicitPref: false });
      };
      handler(mql);
      mql.addEventListener('change', handler);
      return () => mql.removeEventListener('change', handler);
    }
  }, [hasExplicitPref]);

  useEffect(() => {
    if (location.hash) {
      setTimeout(() => {
        const element = document.getElementById(location.hash.substring(1));
        if (element) {
          element.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }, 100);
    } else {
      window.scrollTo(0, 0);
    }
  }, [location]);

  const handleLanguageChange = (newLang) => {
    setLang(newLang);
    saveLanguagePreference(newLang);
  };

  const handleThemeChange = (newTheme) => {
    setThemeState({ theme: newTheme, hasExplicitPref: true });
    saveThemePreference(newTheme);
  };

  const p = usePalette(theme);
  const t = (k) => (i18n[lang] && i18n[lang][k]) || k;

  return (
    <div className={cls(p.rootBg, p.rootText)}>
      <Navbar
        route={location.pathname}
        theme={theme}
        setTheme={handleThemeChange}
        p={p}
        lang={lang}
        setLang={handleLanguageChange}
        t={t}
      />
      <Routes>
        <Route path="/" element={<HomePage p={p} t={t} />} />
        <Route path="/prestations" element={<PrestationsPage p={p} t={t} />} />
        <Route path="/software" element={<SoftwarePage p={p} t={t} />} />
        <Route path="/pricing" element={<PricingPage p={p} t={t} />} />
        <Route path="/recrutement" element={<RecruitmentPage p={p} t={t} />} />
        <Route path="/contact" element={<ContactPage p={p} t={t} />} />
        <Route path="/cookies" element={<CookiePreferencesPage p={p} t={t} theme={theme} />} />
        <Route path="/account-deletion" element={<AccountDeletionPage p={p} t={t} />} />
        <Route path="/privacy" element={<PrivacyPolicyPage p={p} t={t} lang={lang} />} />
      </Routes>
      <Footer p={p} theme={theme} t={t} />
      <ChatModule />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}
